import z from 'zod'

import { StrapiMenuSpecialFunction } from '@/src/domains/strapi/constants'

const CMSPageRelationSchema = z.object({
  slug: z.string(),
  category: z.string().nullish(),
})

const CMSMenuChildSchema = z.object({
  id: z.number(),
  title: z.string(),
  url: z.string().nullish(),
  special_function: z.nativeEnum(StrapiMenuSpecialFunction).nullish(),
  icon_name: z.string().nullish(),
  target: z.string().nullish(),
  description: z.string().nullish(),
  page_relation_one: CMSPageRelationSchema.nullish(),
})

const CMSMenuItemSchema = CMSMenuChildSchema.extend({
  children: z.array(CMSMenuChildSchema).optional(),
})

export type CMSMenuItem = z.infer<typeof CMSMenuItemSchema>

export const CMSMenuSchema = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  items: z.array(CMSMenuItemSchema).optional(),
})
